import { featureFlagKey } from "@redotech/feature-flags-model/keys";

export const ReturnsFlagKey = {
  RETURN_FLOW_OPTIMIZATION_LLM_DIMENSION_ESTIMATES: featureFlagKey(
    "return-flow-optimization-llm-dimension-estimates",
  ), // Use LLM to estimate product dimensions for return label creation when actual data is unavailable
  INSPECT_BEFORE_REFUND: featureFlagKey("inspect-before-refund"), // Reorder processing to inspect/restock items before issuing refund
  MANAGED_RETURNS_TRIAL_ONBOARDING: featureFlagKey(
    "managed-returns-trial-onboarding",
  ), // Gate the Managed Returns trial onboarding to targeted merchant admins
  AUTO_SUBMIT_CLAIMS: featureFlagKey("auto-submit-claims"), // Auto Submit Claims; evaluated per submission method (method attribute in context)
  RETURN_PROCESSING_FLOWS: featureFlagKey("return-processing-flows"), // Enable advanced flow editor for return processing (replaces return/claim processing automations)
  COMPENSATION_AND_RESTOCKING_FLOWS: featureFlagKey(
    "compensation-and-restocking-flows",
  ), // Dark launch: run Compensation and Restocking flows alongside Return Processing Flows on return-ready triggers
  RETURN_PROCESSING_AGENT: featureFlagKey("return-processing-agent"), // Enable AI returns processing agent features (spec generation and evaluation) for a team
  ZIP_CODE_FRAUD: featureFlagKey("zip-code-fraud"), // Enable ZIP-code-based return fraud review in the merchant app
  LIQUIDONATE_DONATION_ROUTING: featureFlagKey("liquidonate-donation-routing"), // Enable Liquidonate donation routing option in the location flow editor
  INTERNATIONAL_RETURNS_READINESS: featureFlagKey(
    "international-returns-readiness",
  ), // Gate the intl-returns customs-readiness RPC/alert/banner. Default OFF.
  NEW_CREATE_SHOPIFY_EXCHANGE_ORDER: featureFlagKey(
    "new-create-shopify-exchange-order",
  ), // ON routes to new createShopifyExchangeOrder; OFF keeps legacy _createExchangeOrder. Per team, default OFF.
  SHOPIFY_RETURNS: featureFlagKey("shopify-returns"), // Shopify return lifecycle for exchange-API returns; per team, default "old".
} as const;
